import { graphql, useStaticQuery } from 'gatsby';

export default function usePastEvent() {
  const { markdownRemark } = useStaticQuery(
    graphql`
      {
        markdownRemark(frontmatter: { slug: { eq: "Past Event" } }) {
          frontmatter {
            date
            title
            path
            src {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    `
  );
  return markdownRemark.frontmatter;
}
